import { TEXT_TYPE_AREA } from './config';

export const CORE_TEXTAREA_PROPS = {
  type: TEXT_TYPE_AREA,
  value: undefined,
  label: null,
  title: null
};
